import tree from '~core/tree'

const loggedIn = function (ctx) {
  if (!tree.get('loggedIn')) {
    ctx.redirect('/sign-up')
  }

  return true
}

module.exports = loggedIn



// WEBPACK FOOTER //
// /home/ec2-user/esquina/esquina/lib/frontend/middlewares/logged-in-to-sign-up.js